<!-- DELETE -->
@if (showDelete && !disabled) {
<div
  data-e2e="delete-delivery-period"
  class="delete-btn d-flex justify-content-center"
>
  <span class="d-flex icons active-icon" (click)="onDelete($event)">
    <fa-icon [icon]="trashIcon" size="1x"></fa-icon>
  </span>
</div>
}

<div
  [class.flex-column]="differentLines"
  [class.justify-content-between]="!differentLines"
  class="d-flex align-items-top w-100 period-title"
>
  @if ( quantity > 0 && { quantity: quantity | number: '1.0-0' }; as
  wrapperObject) {
  <strong data-e2e="calendar-items-container">
    <span
      i18n="
        Config Strip|Total items in basket for a delivery
        period@@deliveryPeriodTotalInBasket"
    >
      {wrapperObject.quantity, plural, =1 {{{ wrapperObject.quantity}} item }
      other {{{wrapperObject.quantity}} items}}
    </span>
  </strong>
  } @else { @if (placeholderLabel) {
  <strong>{{ placeholderLabel }}</strong>
  } }

  <!-- LABEL or Date -->
  @if (customLabel !== undefined) {
  <p data-e2e="delivery-period-in-stock" class="m-0">
    {{ customLabel }}
  </p>
  } @else {
  <epc-delivery-period-date-label
    [intervalType]="intervalType"
    [deliveryData]="deliveryData"
  ></epc-delivery-period-date-label>
  }
</div>

<!-- Copy -->
@if (!disabled) {
<div class="actions d-flex flex-column justify-content-start align-items-end">
  @if (showCopied) {
  <div class="text-primary copiedAnimation">
    <fa-icon [icon]="copiedIcon"></fa-icon>
  </div>
  } @if (!showCopied && showPaste) {
  <span
    [atxTooltip]="pasteTooltipMessage"
    class="d-flex text-primary ml-1 paste-icon-wrapper"
  >
    <span
      data-e2e="copy-delivery-period"
      class="paste-icon"
      (click)="pasteQuantities($event)"
    ></span>
    <fa-icon
      [class.ping-anim]="showAnimation$ | async"
      [icon]="pasteIcon | async"
    ></fa-icon>
  </span>
  }
</div>
}
